/*
 * Author: Dicky Dichandra / Pacdev
 * Copyright (c) 2022 Optikultur Indonesia
 */

import axios from 'axios'
import React, { useRef, useState } from 'react'
import { Card, Container, CardHeader, Typography, Box } from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'

import Button from '@mui/material/Button'
import FileSelector from 'component/FileSelector'

function Home() {
    return (
        <>
            <Card variant="outlined" sx={{ alignItems: 'stretch' }}>
                <CardHeader title="Input Gambar" sx={{ textAlign: 'center' }} />
                <Box maxWidth="lg" sx={{ height: '1' }}>
                    <Box
                        maxWidth="lg"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                        }}
                    >
                        <Typography variant="body1" color="initial">
                            File Gambar
                        </Typography>
                        <Box
                            maxWidth="lg"
                            sx={{
                                display: 'flex',
                                paddingX: '.5em',
                                alignItems: 'center',
                                gap: '8px',
                            }}
                            // how do i set a default value for Box's display?
                        >
                            <FileSelector />
                        </Box>
                    </Box>
                </Box>
                <Box maxWidth="lg" sx={{ alignItems: 'stretch' }}>
                    <Button variant="contained" sx={{ width: '1' }}>
                        Scan Gambar
                    </Button>
                </Box>
            </Card>
            <Card variant="outlined" sx={{ alignItems: 'stretch' }}></Card>
        </>
    )
}

export default Home
